module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "level app-levelbar"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('h3', {
    staticClass: "subtitle is-5"
  }, [_c('strong', [_vm._v(_vm._s(_vm.name))]), _vm._v("("), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.endpoint))])]), _vm._v(")")], 1)])]), _c('div', {
    staticClass: "level-right is-hidden-mobile"
  }, [_c('breadcrumb', {
    attrs: {
      "list": _vm.list
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8486c3e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/layout/Levelbar.vue
// module id = 127
// module chunks = 11